import Loadable from 'app/components/Loadable'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const AccessManagementPage = Loadable(
  lazy(() => import('../pages/accessManagement/index'))
)

const accessManagementRoutes: RouteObject[] = [
  {
    // path: '/access-management',
    // element: <AccessManagementPage />,
  },
]

export default accessManagementRoutes
